import { render, staticRenderFns } from "./PostInTime.vue?vue&type=template&id=34f2919c&"
import script from "./PostInTime.vue?vue&type=script&lang=js&"
export * from "./PostInTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports